import { Box, styled } from "@mui/material";
import { Colors } from "../theme";

export const ExamContainer = styled(Box)(() => ({
  display: "flex",
  minHeight: "95vh",
  marginTop:"-60px",
  gap: "20px",
  padding: "10px",
  "& .confirmation-screen": {
    minWidth: "100%",
    height: "fit-content",
    padding: "0 30px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",

    "& .confirm-flex": {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      maxWidth: "1000px",
      margin: "0 auto",
      width: "100%",

      "& h2": {
        fontSize: "28px",
        fontWeight: "600",
        paddingBottom: "15px",
        borderBottom: "2px solid " + Colors.primary,
        marginBottom: "5px",
      },
    },

    "& .exam-details": {
      backgroundColor: Colors.white,
      padding: "10px 20px",
      borderRadius: "6px",
      border:"1px solid "+Colors.border,
      borderLeft: "4px solid " + Colors.primary,
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",

      "& p": {
        margin: "10px 0",
        color: Colors.garyText,
        fontSize: "15px",
        lineHeight: "1.5",
      },

      "& strong": {
        fontWeight: "600",
      },
    },

    "& .exam-instructions": {
      backgroundColor: Colors.white,
      padding: "20px",
      borderRadius: "6px",
      border:"1px solid "+Colors.border,
      borderLeft: "4px solid #965d00",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",

      "& h3": {
        fontSize: "20px",
        marginBottom: "15px",
        fontWeight: "500",
      },

      "& ul": {
        paddingLeft: "20px",
      },

      "& li": {
        marginBottom: "10px",
        color: Colors.garyText,
        lineHeight: "1.4",
        position: "relative",
        paddingLeft: "5px",
      },
    },

    "& .confirmation-buttons": {
      display: "flex",
      gap: "25px",
      justifyContent: "center",
      marginTop: "10px",

      "& button.button": {
        padding: "12px 30px",
        fontSize: "16px",
        fontWeight: "500",
        borderRadius: "4px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        border: "none",
        outline: "none",

        "&:first-of-type": {
          backgroundColor: Colors.primary,
          color: Colors.white,
          boxShadow: "0 3px 6px rgba(52, 152, 219, 0.3)",

          "&:hover": {
            opacity: "0.8",
            boxShadow: "0 4px 8px rgba(52, 152, 219, 0.5)",
          },
        },

        "&:last-of-type": {
          backgroundColor: Colors.white,
          color: Colors.garyText,
          border: "1px solid "+Colors.border,

          "&:hover": {
            backgroundColor: Colors.hover ,
            color: Colors.white,
          },
        },
      },
    },

    "@media (max-width: 768px)": {
      padding: "20px 15px",
      height: "auto",
      minHeight: "80vh",

      "& .confirmation-buttons": {
        flexDirection: "column",
        padding: "15px 0",
      },
    },
  },
  "& .question-container": {
    width: "100%",
    border: "1px solid "+Colors.border,
    borderRadius: "5px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "column",
    padding: "30px",
    backgroundColor: Colors.white,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    position: "relative",
    overflowY: "auto",
    
  },

  "& .question-header": {
    width: "100%",
    marginBottom: "20px",
    "& .flex-between": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },

    "& h2": {
      color: Colors.gray,
      fontSize: "18px",
      fontWeight: "500",
      marginBottom: "10px",
    },

    "& p": {
      fontSize: "16px",
      lineHeight: "1.5",
      whiteSpace: "pre-line",
    },
  },

  "& .options-container": {
    width: "100%",
    marginBottom: "30px",
  },

  "& .option": {
    padding: "12px",
    fontSize: "16px",
    marginBottom: "10px",
    border: "1px solid "+Colors.border,
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s ease",

    "&:hover": {
      backgroundColor: Colors.hover,
      borderColor: Colors.primary,
      color:"white",
    },
  },

  "& .option-label": {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: "100%",
  },

  "& .option-text": {
    fontSize: "16px",
    marginLeft: "10px",
  },

  "& .navigation-buttons": {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "20px",
    position: "absolute",
    bottom: "0",
    padding: "20px",
  },

  "& .nav-button": {
    padding: "10px 20px",
    backgroundColor: Colors.primary,
    color: Colors.white,
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "background-color 0.2s",

    "&:hover": {
      backgroundColor: Colors.hover,
    },

    "&:disabled": {
      backgroundColor: Colors.hover,
      cursor: "not-allowed",
    },
  },

  "& .question-list": {
    width: "550px",
    border: "1px solid "+Colors.border,
    borderRadius: "8px",
    padding: "20px",
    backgroundColor: Colors.white,
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
    "& .timer": {
      border: "1px solid "+Colors.border,
      borderRadius: "5px",
      marginTop: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100px",
      "& .MuiGauge-valueArc": {
        fill: Colors.primary,
      },
    },
    "& h3": {
      color: Colors.gray,
      fontSize: "18px",
      fontWeight: "500",
    },
    "@media (max-width:899px)": {
      display: "none",
    },
  },

  "& .question-grid": {
    border: "1px solid "+Colors.border,
    borderRadius: "5px",
    padding: "10px",
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "10px",
    marginTop: "15px",
    marginBottom: "20px",
  },

  "& .question-number": {
    height: "50px",
    width: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid "+Colors.border,
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.3s",

    "&.active": {
      backgroundColor: Colors.primary,
      color: Colors.white,
      fontWeight: "600",
    },

    "&.answered": {
      backgroundColor: Colors.light_gray,
      color:Colors.text,
      borderColor: Colors.primary,
    },

    "&.active.answered": {
      backgroundColor: Colors.primary,
      color: Colors.white,
    },
  },

  "& .timer-display": {
    "@media (min-width:899px)": {
      display: "none",
    },
  },

  "& .timer-warning": {
    color: "red",
    fontWeight: "600",
  },

  "& .result-container": {
    width: "100%",
    textAlign: "center",

    "& h2": {
      marginBottom: "20px",
      color: Colors.garyText,
    },
  },

  "& .result-summary": {
    marginTop: "20px",
  },

  "& .passed-text": {
    color: "green",
    fontWeight: "600",
  },

  "& .failed-text": {
    color: "red",
    fontWeight: "600",
  },

  "& .retry-button": {
    marginTop: "20px",
    padding: "10px 20px",
    backgroundColor: Colors.primary,
    color: Colors.white,
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",

    "&:hover": {
      backgroundColor: Colors.hover,
    },
  },

  "@media (max-width:899px)": {
    padding: "5px",
  },
}));

export const ExamResultContainer = styled(Box)(() => ({
  "& .result-paper": {
    maxWidth: "800px",
    margin: "0 auto",
    padding: 32,
    borderRadius: 16,
    overflow: "hidden",
    position: "relative",
  },

  "& .result-accent": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "8px",
  },

  "& .result-title": {
    textAlign: "center",
    fontWeight: 600,
    marginBottom: 24,
    marginTop: 8,
  },

  "& .gauge-container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  "& .gauge-wrapper": {
    position: "relative",
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
  },

  "& .gauge": {
    position: "relative",
    display: "inline-flex",
  },

  "& .gauge-background": {
    color: Colors.garyText,
  },

  "& .gauge-progress": {
    position: "absolute",
    left: 0,
  },

  "& .gauge-content": {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },

  "& .gauge-percentage": {
    fontWeight: "600",
    marginLeft: "1rem",
  },

  "& .gauge-label": {
    color: "text.secondary",
  },

  "& .result-status": {
    marginTop: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  "& .status-icon": {
    fontSize: 28,
    marginRight: 8,
  },

  "& .status-text": {
    fontWeight: 600,
  },

  "& .details-container": {
    paddingLeft: { xs: 0, sm: 16 },
  },

  "& .details-title": {
    fontWeight: 500,
    marginBottom: 8,
  },

  "& .details-box": {
    backgroundColor: "background.paper",
    padding: 16,
    borderRadius: 8,
    border: "1px solid",
    borderColor: "divider",
  },

  "& .details-row": {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: 12,
  },

  "& .details-label": {
    fontWeight: 400,
  },

  "& .details-value": {
    fontWeight: 500,
  },

  "& .details-score-value": {
    fontWeight: 600,
  },

  "& .details-divider": {
    margin: "12px 0",
  },

  "& .time-info": {
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
  },

  "& .time-icon": {
    marginRight: 8,
    color: "text.secondary",
  },

  "& .time-text": {
    color: "text.secondary",
  },

  "& .message-box": {
    marginTop: 12,
    padding: 12,
    borderRadius: 8,
    border: "1px solid",
  },

  "& .message-text": {
    fontSize: 14,
  },

  "& .button-container": {
    marginTop: 32,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    gap: "10px"
  },

  "& .retry-button": {
    paddingLeft: 32,
    paddingRight: 32,
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: Colors.primary,
    "&:hover": {
      opacity: 0.8,
    },
  },
}));
